import type { Dispatch } from "redux"
import { performRESTRequest } from "@ng-mw/framework-core"
import { Logger, Cacher } from "@ng-mw/shared-react-components"
// import getISOWeek from "date-fns/getISOWeek"
// import getISOWeekYear from "date-fns/getISOWeekYear"

import * as weekMenuActions from "./weekmenuActionCreators"
import { WeekmenuData } from "@app/types/root-state/weekmenu"

// const PAGESIZE = 6

const CACHE_KEY = "weekMenu"

// Det er laget et eget endepunkter for uthenting av ukemenyer
//
// /api/weeklyrecipeservice (alle ukemenyer)
// /api/weeklyrecipeservice/{year} (ukemenyer for angitt år)
// /api/weeklyrecipeservice/{year}/{week} (ukemeny for angitt år og uke)

function getFullLocalUrl(absolutePath: string) {
    const params = new URLSearchParams(document.location.search.substring(1))
    const env = params.get("env")
    if (env === "2") {
        return `https://menyweb.trumffrontend.systest.trumf.cloud${absolutePath}`
    } else if (env === "3") {
        return `https://meny.no${absolutePath}`
    }
    return `https://${window.location.host}${absolutePath}`
}

export function getWeekMenuCacheKey(year?: number, weekNumber?: number) {
    return year && weekNumber ? `${year}-${weekNumber}` : "latest"
}

export function getWeekMenu(year?: number, weekNumber?: number) {
    return async function (dispatch: Dispatch) {
        dispatch(weekMenuActions.getWeekMenuLoading())

        // const today = new Date()
        // const currentYear = getISOWeekYear(today)
        // const currentWeekNumber = getISOWeek(today)

        try {
            const predicate = { key: getWeekMenuCacheKey(year, weekNumber) }
            const cached = (await Cacher.get(CACHE_KEY, predicate)) as WeekmenuData[]
            if (cached) {
                dispatch(weekMenuActions.getWeekMenuFromCache(cached))
            } else {
                const data = (await performRESTRequest({
                    // url: getFullLocalUrl((year && weekNumber) ? `/api/weeklyrecipeservice/${year}/${weekNumber}` : `/api/weeklyrecipeservice/latest/${currentYear}/${currentWeekNumber}`),
                    url: getFullLocalUrl(
                        year && weekNumber
                            ? `/api/weeklyrecipeservice/${year}/${weekNumber}`
                            : "/api/weeklyrecipeservice/latest",
                    ),
                    method: "GET",
                })) as WeekmenuData[]

                dispatch(weekMenuActions.getWeekMenuSuccess(data))
                // save response data to cache
                Cacher.cache(CACHE_KEY, predicate, data)
            }
        } catch (e: any) {
            dispatch(weekMenuActions.getWeekMenuError(e))
            Logger.error("actions/weekMenuActions/getWeekMenu()", e)
        } finally {
            dispatch(weekMenuActions.getWeekMenuLoaded())
        }
    }
}

// export function getAllWeekMenus(year?: number, page?: number) {
//     return async function (dispatch: Dispatch) {
//         dispatch(weekMenuActions.getAllWeekMenusLoading())

//         try {
//             const data = await performRESTRequest({
//                 url: getFullLocalUrl(
//                     year
//                         ? `/api/weeklyrecipeservice/${year}?page=${page || 1}&pageSize=${PAGESIZE}`
//                         : `/api/weeklyrecipeservice/?page=${page || 1}&pageSize=${PAGESIZE}`,
//                 ),
//                 method: "GET",
//             })

//             dispatch(weekMenuActions.getAllWeekMenusSuccess(data))
//         } catch (e: any) {
//             dispatch(weekMenuActions.getAllWeekMenusError(e))
//             Logger.error("actions/weekMenuActions/getAllWeekMenus()", e)
//         } finally {
//             dispatch(weekMenuActions.getAllWeekMenusLoaded())
//         }
//     }
// }
